export * from 'store/bolt/trackingV2.js';
// import * as base from 'store/bolt/trackingV2.js';
import { accessNested } from 'utils/utils';
import Store from 'store/store';

if (USE_TRACKING_V2) {
	
	const fireLionsgateTracking = () => {
		const store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			const locale = accessNested(store, 'appData.meta.title.locale', '');
			const { dxNumber, genres, distributionWindow } = lionsgateAdswerve_Old ? lionsgateAdswerve_Old : lionsgateAdswerve;

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'dataLayer-initialized',
				titleName: locale,
				dxNumbers: dxNumber,
				genre: genres,
				environment: 'prod',
				distributionWindow: distributionWindow,
				pageContentType: 'movie',
				siteType: 'standalone movie site'
			});
		}
	};

	Store.on('LANDING', () => {
		let store = Store.get();
		const lionsgateAdswerve_Old = accessNested(store, 'appData.apis.tracking.lionsgateAdswerve');
		const lionsgateAdswerve = accessNested(store, 'appData.options.lionsgateAdswerve');
		if (lionsgateAdswerve_Old || lionsgateAdswerve) {
			fireLionsgateTracking();
		}
	});
}